import { KPI } from '@/hooks/useCampaigns';
import { TimeFrame } from '@/hooks/useInstagramAccountOverview';

export enum QueryKeys {
  Teams = 'teams',
  ActiveTeam = 'activeTeam',
  User = 'user',
  InstagramAccount = 'instagramAccountOverview',
  FacebookAccounts = 'facebookAccounts',
  TeamMembers = 'teamMembers',
  TeamInvites = 'teamInvites',
  Campaigns = 'campaigns',
  Campaign = 'campaign',
  DeleteCampaign = 'deleteCampaign',
  RecommendedKpi = 'recommendedKpi',
  FacebookMedia = 'facebookMedia',
  DownloadCampaign = 'downloadCampaign',
  Report = 'report',
  ReportPeriods = 'reportPeriods',
  StripeCustomer = 'stripeCustomer',
  StripeProducts = 'stripeProducts',
}

export const getTeamsQueryKey = () => {
  return [QueryKeys.Teams];
};

export const getActiveTeamQueryKey = () => {
  return [QueryKeys.ActiveTeam];
};

export const getUserQueryKey = () => {
  return [QueryKeys.User];
};

export const getInstagramAccountQueryKey = (
  accountId: string,
  timeFrame: TimeFrame,
) => {
  return [QueryKeys.InstagramAccount, accountId, timeFrame];
};

export const getTeamMembersQueryKey = () => [QueryKeys.TeamMembers];

export const getTeamInvitesQueryKey = () => [QueryKeys.TeamInvites];

export const getFacebookAccountsQueryKey = () => {
  return [QueryKeys.FacebookAccounts];
};

export const getCampaignsQueryKey = () => [QueryKeys.Campaigns];

export const getRecommendedKpiQueryKey = () => [QueryKeys.RecommendedKpi];

export const getFacebookMediaQueryKey = () => [QueryKeys.FacebookMedia];

export const getCampaignQueryKey = (campaignId?: string) => [
  QueryKeys.Campaign,
  campaignId,
];

export const getDownloadCampaignQueryKey = (campaignId?: string) => [
  QueryKeys.DownloadCampaign,
  campaignId,
];

export const getReportQueryKey = (reportId?: string, kpi?: KPI) => [
  QueryKeys.Report,
  reportId,
  kpi,
];

export const getReportPeriodsQueryKey = () => [QueryKeys.ReportPeriods];

export const getStripeCustomerQueryKey = () => [QueryKeys.StripeCustomer];

export const getStripeProductsQueryKey = () => [QueryKeys.StripeProducts];

export const getDeleteCampaignQueryKey = () => [QueryKeys.DeleteCampaign];
